import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import ProjectsSection from './components/ProjectsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FounderSection } from './components/FounderSection';
import { HowWeWorkSection } from './components/HowWeWorkSection';
import { ServicesDetailSection } from './components/ServicesDetailSection';
import { GetStarted } from './components/GetStarted';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { BackToMenuButton } from './components/ui/BackToMenuButton';

export default function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <ProjectsSection />
        <TestimonialsSection />
        <FounderSection />
        <HowWeWorkSection />
        <ServicesDetailSection />
        <GetStarted />
        <ContactSection />
        <Footer />
        <BackToMenuButton />
      </div>
    </LanguageProvider>
  );
}

